<div class="flex gap-3 flex-wrap mt-3">
    <div class="flex-nowrap flex gap-2 align-items-center" *ngIf="questionPageHiddenLog > 0">
        <img src="assets/vinter/icons/cheating-icon.svg">
        <p class="font-medium page-hidden">{{"Key.SwitchTab" | translate: {value: questionPageHiddenLog } }}</p>
    </div>
    <div *ngIf="answer?.isFaceDetected && answer?.isAllowedDifferentFaceAnalysis" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-icon.svg" class="detect-img">
        <p class="font-medium face-detected">{{"Key.FaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.isMultiFaceDetected && answer?.isAllowedMultipleFaceAnalysis" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/multiface-detected-icon.svg" class="detect-img">
        <p class="font-medium multiface-detected">{{"Key.MultiFaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
     answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace" class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-status-icon.svg" class="detect-img">
        <p class="font-medium impropriety-speech">{{"Key.FaceDetectionStatus" | translate }}</p>
    </div>
</div>

<div class="flex">
    <img src="assets/vinter/icons/text-questioncoktan-secmeli-cevap-icon-arrow-back-up.svg">
    <h5 class="text-justify answer-title font-semibold text-lg ml-2">
        {{"Key.Answer" | translate}}
    </h5>
</div>

<div class="ml-5 flex" *ngIf="answer === null">
    <img src="assets/vinter/icons/not-answered.svg">
    <p class="ml-2 empty-answer-text">{{"Key.QuestionNotAnswered" | translate}}</p>
</div>

<div *ngIf="answer?.answerContent ?? false" class="answer-container grid">
    <div class="col-12 md:col-12 lg:col-12 lg:px-3">
        <div class="answer-text-container overflow-y-auto p-3 border-1 border-solid border-gray-50 border-round-lg">
            <span *ngFor="let word of erroredDataText" [style.background-color]="word.class" class="question-answer line-height-3"
                tooltipPosition="top"
                [ngClass]="{'text-white errored-text': word.isError,'whiteSpace': word.word.trim() === ''}"
                (mouseover)="errorPopup(word, op,$event)" (mouseleave)="op.hide()"
                tooltipStyleClass="pronunciationTooltip">
                {{ word.word }}
            </span>
            <p-overlayPanel #op>
                <ng-template pTemplate="content">
                    <div class="flex flex-wrap">
                        <div *ngFor="let error of errorPopupData" class="w-full">
                            <span class="text-gray-600 text-s font-semibold">{{'Key.'+error.errorCategory |
                                translate}}</span>
                            <p class="text-gray-600 text-xs mb-1">
                                {{"("+error.ruleID+")"}}</p>
                            <p class="text-red-500 text-xs line-through font-italic mb-0 mt-3">
                                {{error.wrongText}}</p>
                            <p class="text-blue-500 text-xs mb-0">{{error.description}}</p>
                        </div>
                    </div>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>
</div>
